import { faHeart, faPhoneAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

export default [
  {
    path: "/about",
    text: "About Us",
    icon: <FontAwesomeIcon icon={faHeart} />,
  },
  {
    path: "/contact",
    text: "Contact us",
    icon: <FontAwesomeIcon icon={faPhoneAlt} />,
  },
];
